import { Injectable } from '@angular/core';
import { FieldType } from 'angular-slickgrid';
import { masterGridConfig } from '../../../app-enum.enum';

@Injectable()
export class DriverSummaryService {

  driverFilterConfigs = {
    'showSideBar': false,
    'showReset': true,
    'isReset': true
  };

  constructor() { }

  //search
  getDriverFilterTemplate() {
    return [{
      'id': 'strDriverCodeFrom',
      'labelName': 'Driver code',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'isReadOnly': false,
      'isVisible': true,
      'validations': [],
      'position': 1,
      'class': 'col-md-12',
    }, {
      'id': 'strDriverName',
      'labelName': 'Driver Name',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'isReadOnly': false,
      'isVisible': true,
      'validations': [],
      'position': 2,
      'class': 'col-md-12'
    }, {
      'id': 'str3plOwnerName',
      'labelName': 'Carrier Name',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'isReadOnly': false,
      'isVisible': true,
      'validations': [],
      'position': 3,
      'class': 'col-md-12',
    }, {
      'id': 'strDriverType',
      'labelName': 'Driver Type',
      'type': 'search',
      'placeholder': '',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 4,
      'class': 'col-md-12'
    }, {
      'id': 'strStatus',
      'labelName': 'Status',
      'type': 'search',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': '',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [{
        name: 'ALL',
        id: 'ALL'
      }],
      'validations': [],
      'position': 5,
      'class': 'col-md-12'
    }, {
      'id': 'strAvailabilityStatus',
      'labelName': 'Availability Status',
      'type': 'search',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': '',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [{
        value: 'All',
        id: 'ALL'
      }],
      'validations': [],
      'position': 6,
      'class': 'col-md-12'
    }, {
      'id': 'strDriverLicenceNo',
      'labelName': 'Driver Licence No',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-12',
    }, {
      'id': 'strIvmsKeyNo',
      'labelName': 'IVMS Blue Key No',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-12',
    }, {
      'id': 'searchButton',
      'buttonName': 'Search',
      'onClickEvent': '',
      'onChangeEvent': '',
      'isVisible': true,
      'type': 'button',
      'isSearchBtn': true
    }];
  }

  //grid
  getDriverTableColumnConfigs(scope) {
    return [{
      id: 'id',
      name: 'Seq No',
      field: '',
      sortable: true,
      formatter: function (row) { return (row + 1); },
      columnGroup: 'Driver Details',
      minWidth: 45
    }, {
      id: 'DRIVER_CODE',
      name: 'Driver Code',
      field: 'DRIVER_CODE',
      sortable: true,
      type: FieldType.string,
      onclick: scope['navigateToCreateScreen'],
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<a class="cursor-pointer">' + value + '</a>';
      },
      columnGroup: 'Driver Details',
      minWidth: 150
    }, {
      id: 'DRIVER_NAME',
      name: 'Driver Name',
      field: 'DRIVER_NAME',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 230
    }, {
      id: 'PHONE_NO',
      name: 'Driver Phone No',
      field: 'PHONE_NO',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 150
    }, {
      id: 'DRIVER_TYPE',
      name: 'Driver Type',
      field: 'DRIVER_TYPE',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 150
    }, {
      id: 'OWNER_NAME_3PL',
      name: 'Carrier Name',
      field: 'OWNER_NAME_3PL',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 150
    }, {
      id: 'IVMS_BLUEKEYID',
      name: 'IVMS Blue Key No',
      field: 'IVMS_BLUEKEYID',
      sortable: true,
      columnGroup: 'Driver Details',
      minWidth: 150
    }, {
      id: 'AVAILABILITY_STATUS',
      name: 'Availability Status',
      field: 'AVAILABILITY_STATUS',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 120
    }, {
      id: 'STATUS',
      name: 'Status',
      field: 'STATUS',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 80
    }, {
      id: 'NATIONALITY_ID',
      name: 'Driver Nationality',
      field: 'NATIONALITY_ID',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 150
    }, {
      id: 'POSITION',
      name: 'Position',
      field: 'POSITION',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Driver Details',
      minWidth: 150
    }];
  }

  getDriverTableConfigs(scope) {
    return {
      gridId: 'DriverListTable',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: 'Driver Details',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      showFilter: true,
      showAdvanceFilter: true,
      canCopyRows: false,
      showColumnFilter: false,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: false,
      enableRowSelection: true,
      editable: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true
      },
      autoResize: {
        maxHeight: masterGridConfig.gridHeightForMasterList,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: true,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      hideClearAllFiltersCommand: true,
      hideClearAllSortingCommand: true,
      hideToggleFilterCommand: true,
      hideExportCsvCommand: true,
      hideExportTextDelimitedCommand: true,
      hideRefreshDatasetCommand: true,
      enableHeaderMenu: true,
      alwaysShowVerticalScroll: false,
      forceFitColumns: false
    };
  }
}